import {
	SAVE_TEXT,
	SAVE_URL_LIST,
	SAVE_SELECTED_URL_LIST,
	UPDATE_URL_LIST,
	UPDATE_ACCOUNT_LIST,
	DELETE_URL_LIST,
	DELETE_SELECTED_URL_LIST,
	DELETE_DUPLICATE_URL_LIST
} from './actionTypes'

export function saveText(text) {
	return {
		type: SAVE_TEXT,
		text
	}
}

export function saveUrlList(urlList) {
	return {
		type: SAVE_URL_LIST,
		urlList
	}
}

export function saveSelectedUrlList(urlList) {
	return {
		type: SAVE_SELECTED_URL_LIST,
		urlList
	}
}

export function updateUrlList(urlList) {
	return {
		type: UPDATE_URL_LIST,
		urlList
	}
}

export function updateAccountList(accountUrl) {
	return {
		type: UPDATE_ACCOUNT_LIST,
		accountUrl
	}
}

export function deleteUrlList() {
	return {
		type: DELETE_URL_LIST
	}
}

export function deleteSelectedUrlList(urlList) {
	return {
		type: DELETE_SELECTED_URL_LIST
	}
}

export function deleteDuplicateList() {
	return {
		type: DELETE_DUPLICATE_URL_LIST
	}
}